module.exports = __webpack_public_path__ + "static/media/3.5a4eb863.jpg";